import * as React from 'react';
const SvgFileText = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M20 9v-.76c0-.8-.32-1.56-.88-2.12l-3.24-3.24c-.56-.56-1.33-.88-2.12-.88H8.8c-1.68 0-2.52 0-3.16.33-.56.29-1.02.75-1.31 1.31C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.33 3.16.29.56.75 1.02 1.31 1.31.64.33 1.48.33 3.16.33h6.4c1.68 0 2.52 0 3.16-.33.56-.29 1.02-.75 1.31-1.31.33-.64.33-1.48.33-3.16V10h-2v7.2c0 1 0 2.04-.11 2.25-.1.19-.25.34-.44.44-.21.11-1.25.11-2.25.11H8.8c-1 0-2.04 0-2.25-.11-.19-.1-.34-.25-.44-.44C6 19.24 6 18.2 6 17.2V6.8c0-1 0-2.04.11-2.25.1-.19.25-.34.44-.44C6.76 4 7.8 4 8.8 4H14v1c0 1.4 0 2.1.27 2.64.24.47.62.85 1.09 1.09C15.89 9 16.59 9 18 9z"
    />
    <path
      fill="currentColor"
      d="M15.73 13.95c.09-.05.17-.12.22-.22.03-.06.04-.12.05-.22v-.99c0-.11-.02-.19-.05-.25a.5.5 0 0 0-.22-.22.5.5 0 0 0-.18-.05H8.81c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.05.11-.05.25-.05.53v.4c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.14.05.25.05h6.67c.28 0 .42 0 .53-.05M11.73 16.05s-.11-.04-.18-.05H8.81c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.05.11-.05.25-.05.53v.4c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.14.05.25.05h2.67c.28 0 .42 0 .53-.05.09-.05.17-.12.22-.22.03-.06.04-.12.05-.22v-.99c0-.11-.02-.19-.05-.25a.5.5 0 0 0-.22-.22"
    />
  </svg>
);
export default SvgFileText;
